import { ErrorMessageOptions, getApiError } from './apiError'

export const extractErrorMessage = (
  error: unknown,
  fallbackMessage?: string,
  options?: ErrorMessageOptions
) => {
  const { errorMessage, status } = getApiError(error, options)

  // Override the default API rate limit error message with a user-friendly message.
  // Example of an API error message when rate limit is exceeded:
  // "Request was throttled. Expected available in 3437 seconds."
  if (status === 429) {
    return 'Too many requests. Please try again later.'
  }

  return errorMessage || fallbackMessage || 'An unexpected error occurred.'
}
